import React from 'react';
import Modal from "antd/lib/modal/Modal";
import { IEventViewModal } from "../../../type/events.types";
import {
    CalendarOutlined,
    ClockCircleOutlined,
    DeleteOutlined,
    EditOutlined,
    EnvironmentOutlined
} from "@ant-design/icons";
import { Button } from "antd";
import Locale from "../../../../../core/locale/locale";
import dayjs from 'dayjs';
import EventCoverImage from "../../../utils/event-cover-image";
import "../../../../../styles/component/event-view-modal.scss";
import { Event_Type } from "../../../../../constant/constant";
import { updateEvent } from "../../../action/events.actions";


const EventViewModal: React.FC<IEventViewModal> = (props) => {

    const event = props.data

    const formattedEvent = {
        title: event.name,
        startDate: dayjs(event.startDate).format(Locale.displayDateLong),
        endDate: dayjs(event.endDate || event.startDate).format(Locale.displayDateLong),
        time: event.startTime && event.endTime
            ? `${dayjs(`${event.startDate}T${event.startTime}`).format(Locale.displayTimeShort)} - 
       ${dayjs(`${event.startDate}T${event.endTime}`).format(Locale.displayTimeShort)}`
            : null,
        eventType: Event_Type[event.eventType as keyof typeof Event_Type],
        venue: event.venue,
        hostBy: event.hostBy,
        description: event.description
    }

    const getInitials = (name: string = ''): string =>
        name.trim().split(/\s+/).filter(Boolean).map(word => word.charAt(0).toUpperCase()).join('');

    function handleEditModalOpen() {
        props.openEditEventModal(props.data.id);
        props.handleModalClose();

    }

    async function updateEventCoverImage(docId: string) {
        const payload = {...props.data, coverImageId: docId};
        await updateEvent(props.data.id, payload);
    }

    const ModalFooter = () => (
        <div className="event-modal__footer">
            {props.isAdmin && <Button
                className={`event-modal__btn event-modal__btn--delete ${props.data.eventType === 'events' ? "show" : 'hide'}`}
                icon={<DeleteOutlined/>}
                onClick={() => props.handleDeleteEvent(props.data.id)}
            >
                Delete
            </Button>}


            <Button className="event-modal__btn event-modal__btn--close" onClick={props.handleModalClose}>
                Close
            </Button>

            {props.isAdmin &&
            <Button
                className={`event-modal__btn event-modal__btn--edit ${props.data.eventType === 'events' ? "show" : 'hide'}`}
                icon={<EditOutlined/>}
                onClick={handleEditModalOpen}
            >
                Edit Event
            </Button>
            }

        </div>
    )

    return (
        <Modal
            open={props.open}
            onCancel={props.handleModalClose}
            className="hrms-app event-modal"
            wrapClassName="event-modal-wrapper"
            footer={<ModalFooter/>}
            transitionName=""
        >
            <EventCoverImage
                isAdmin={props.isAdmin}
                className="event-modal__banner-img"
                event={props.data}
            />
            <div className="event-modal__container">
                <div className="event-modal__header">
                    <span className="event-modal__type">{formattedEvent.eventType}</span>
                    <h1 className="event-modal__title">{formattedEvent.title}</h1>
                </div>

                <div className="event-modal__details">

                    <div className="event-modal__detail-item">
                    <span className="event-modal__icon">
                        <CalendarOutlined/>
                    </span>
                        <span className={'event-modal__info'}>
                          <label className="event-modal__label">Start Date</label>
                        <span className="event-modal__value">{formattedEvent.startDate}</span>
                        </span>

                    </div>

                    <div className="event-modal__detail-item">
                    <span className="event-modal__icon">
                        <CalendarOutlined/>
                    </span>
                        <span className={'event-modal__info'}>
                        <label className="event-modal__label">End Date</label>
                        <span className="event-modal__value">{formattedEvent.endDate}</span>
                        </span>
                    </div>
                    {formattedEvent.time &&
                    <div className="event-modal__detail-item">
                    <span className="event-modal__icon">
                        <ClockCircleOutlined/>
                    </span>
                        <span className={'event-modal__info'}>
                        <label className="event-modal__label">Time</label>
                        <span className="event-modal__value">
                       {formattedEvent.time}
                    </span>
                        </span>
                    </div>
                    }

                    <div className="event-modal__detail-item">
                    <span className="event-modal__icon">
                        <EnvironmentOutlined/>
                    </span>
                        <span className={'event-modal__info'}>
                        <label className="event-modal__label">Venue</label>
                        <span className="event-modal__value">
                            {formattedEvent.venue}
                        </span>
                        </span>
                    </div>
                </div>


                <div className="event-modal__extra">

                    <div className="event-modal__section">
                        <div className="event-modal__section-head">
                            <label className="event-modal__section-label">
                                Hosted By
                            </label>
                            <span className="event-modal__section-divider"/>
                        </div>

                        <span className="event-modal__section-value">
                             <div className={"user-avatar"}>
                                 {getInitials(formattedEvent.hostBy)}
                                </div>
                            {formattedEvent.hostBy}
                       </span>

                    </div>

                    <div className="event-modal__section">
                        <div className="event-modal__section-head">
                            <label className="event-modal__section-label">
                                Description
                            </label>
                            <span className="event-modal__section-divider"/>
                        </div>
                        <div className="event-modal__description"
                             dangerouslySetInnerHTML={{__html: formattedEvent.description}}  />


                    </div>

                </div>

            </div>
        </Modal>
    )
}


export default EventViewModal;
